import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import type { RootState } from "../store/store";
import { LOGINPAGE } from "../views/auth/routes";
import { HOMEPAGE } from "../views/home/routes";
import { isSupervisorFromToken } from "../utils/authToken";
import { isTokenValid } from "../utils/isTokenValid";

type Props = { children: React.ReactElement };

const SupervisorRoute: React.FC<Props> = ({ children }) => {
  const rehydrated = useSelector((s: RootState) => !!(s as any)._persist?.rehydrated);
  const token = useSelector((s: RootState) => (s as any).auth?.accessToken);

  if (!rehydrated) return null;

  if (!isTokenValid(token)) return <Navigate to={LOGINPAGE()} replace />;
  if (!isSupervisorFromToken(token)) return <Navigate to={HOMEPAGE()} replace />;

  return children;
};

export default SupervisorRoute;
